import { Component, OnInit } from '@angular/core';
import { BackendService } from '../core/services/backend.service';
import { ActivatedRoute/*, Router*/ } from '@angular/router';
import { StorageService } from '../core/services/storage.service';
// import { environment } from '../../environments/environment';
import { PopupService } from '../core/services/popup.service';
import { Documents, LoadedDocument, RequestedDocument } from '../core/services/utility.service';
import { FileService } from '../core/services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { CapitalizeFirstPipe } from '../core/pipes/capitalize-first.pipe';
import { mergeMap } from 'rxjs/operators';

/**
	Used for a quick check on double loading of the same file
*/
interface LoadedFile {
	name: string;
	size: number;
	/**
	Used when removing a document: we have no further reference to the name
	*/
	numeroPagina: number;
}

interface LoadedFiles { [codiceTipoDocumento: string]: LoadedFile[]; }

@Component({
	selector: 'app-docs',
	templateUrl: './docs.component.html',
	styleUrls: ['./docs.component.scss']
})


export class DocsComponent implements OnInit {
	private qs: string;
	docs: Documents;
	// readonly maxSize = 5242880; // 5 MiB
	readonly maxSize = 5000000; // 5 MB - THIS IS THE CORRECT LIMIT
	readonly maxFiles = 9;
	loadedFiles: LoadedFiles = {}; // temporary name/size list of loaded files, to keep track of already-loaded ones
	constructor(
		private backendService: BackendService,
		private route: ActivatedRoute,
		// private router: Router,
		private translate: TranslateService,
		private storageService: StorageService,
		// private formBuilder: FormBuilder,
		private popupService: PopupService,
		private fileService: FileService,
		private capitalizeFirst: CapitalizeFirstPipe
	) { }

	ngOnInit() {
		this.route.queryParams.subscribe(params => {
			this.qs = params.qs;
			const cdcss = document.getElementById('cdcss'),
				uri = window.location.href.split('&code', 2)[0],
				encodedURI = uri; // encodeURIComponent() window.location.href;
			// console.log('queryString:', this.qs, 'cdcss:', params.cdcss, 'code:', params.code, 'encodedURI:', encodedURI);
			switch (params.cdcss) {
				case 'APPLE':
					cdcss.setAttribute('href', './assets/styles/apple.css');
					break;
				case 'UNIEURO':
					cdcss.setAttribute('href', './assets/styles/unieuro.css');
			}
			if (this.qs) {
				if (params.code) {
					this.backendService.getAccessToken(params.code, encodedURI)
						.subscribe(() => {
							this.backendService.getCorrelationId()
								.pipe(
									mergeMap(() => this.backendService.iniziaProcesso(this.qs))
								)
								.subscribe(result => {
									this.storageService.setToSessionStorage('token', result.token);
									this.backendService.recuperaFileCaricati()
										.subscribe(docs => {
											this.docs = docs;
											for (const doc of docs.documentiRichiesti) {
												doc.nDocumentiCaricati =
													docs.documentiCaricati.filter(
														x => x.flagConfermato === false && x.codiceTipoDocumento === doc.codiceTipoDocumento
													).length;
											}
										},
											error => {
												console.error(error);
												this.popupService.show('ERROR', 'ERR-GEN', false, true);
											}
										);
								},
									error => {
										console.error(error);
										this.popupService.show('ERROR', 'ERR-GEN', false, true);
									}
								);
						},
							error => {
								console.error(error);
								this.popupService.show('ERROR', 'ERR-GEN', false, true);
							}
						);
				} else {
					// const url = new URL(environment.tokenAuthorizePath),
					// search = url.searchParams;
					// search.set('client_id', environment.clientId);
					// search.set('redirect_uri', location.href);
					// url.search = search.toString();
					// location.href = url.href;
					this.popupService.show('WARNING', 'ERR_GEN', true);
				}
			} else {
				this.popupService.show('WARNING', 'ERR_GEN', true);
			}
		});
	}

	/**
	 * downloads and shows the selected document
	 */
	clickDoc(doc: LoadedDocument) {
		this.popupService.hide();
		const w = window.open('./assets/img/logo_Agos.svg', '', 'width=600,height=450');
		this.backendService.visualizzaDocumento(doc.codiceTipoDocumento, doc.numeroPagina)
			.subscribe(result => {
				const blobbone = new Blob([result], { type: result.type });
				if (window.navigator && window.navigator.msSaveOrOpenBlob) // it's IE
				{
					w.close();
					window.navigator.msSaveOrOpenBlob(blobbone, `doc.${result.type.split("/")[1]}`)
				}
				else {
					const resultURL = URL.createObjectURL(blobbone);
					if (result.type.includes('image') && result.type !== 'image/tiff') {
						const img = new Image();
						img.onload = () => {
							w.resizeTo(img.naturalWidth, img.naturalHeight);
						};
						img.src = resultURL;
					}
					w.location.href = resultURL;
					w.addEventListener('unload', (/*event*/) => {
						URL.revokeObjectURL(resultURL);
					});
				}
			},
				error => {
					console.error(error);
				}
			);
	}

	/**
	 * removes the selected document
	 */
	deleteDoc(doc: LoadedDocument) {
		this.popupService.hide();
		this.backendService.eliminaDocumento(doc.codiceTipoDocumento, doc.numeroPagina)
			.subscribe(() => {
				this.docs.documentiCaricati.splice(this.docs.documentiCaricati.indexOf(doc), 1);
				this.docs.documentiRichiesti.find(x => x.codiceTipoDocumento === doc.codiceTipoDocumento).nDocumentiCaricati--;
				this.popupService.show('CONFIRM', 'DOC_DELETED');
				if (this.loadedFiles[doc.codiceTipoDocumento]) { // the file may have been uploaded in past, and not be present in loadedFiles
					const i = this.loadedFiles[doc.codiceTipoDocumento].findIndex(f => doc.numeroPagina === f.numeroPagina)
					if (i !== -1) {
						this.loadedFiles[doc.codiceTipoDocumento].splice(i, 1);
					} // removing the reference in loaded files temporary list

				}
			},
				error => {
					console.error(error);
					if (error.status === 500) {
						switch (error.error.codiceErrore) {
							case 'DOC_NOT_FOUND':
								this.popupService.show('WARNING', 'DOC_NOT_FOUND');
								break;
							case 'DOC_CONFIRMED':
								this.popupService.show('WARNING', 'DOC_YET_CONFIRMED');
						}
					} else {
						// if codiceErrore === 'GENERIC_ERROR'
						this.popupService.show('WARNING', 'ERR_GEN');
					}
				}
			);
	}

	/**
	 * click on upload button
	 * @param event - files selected
	 * @param codiceTipoDocumento - code type doc
	 */
	onFileChange(event, doc: RequestedDocument) {
		const file: File = event.target.files[0];
		if (
			!this.loadedFiles[doc.codiceTipoDocumento]
			||
			this.loadedFiles[doc.codiceTipoDocumento].every(d => d.name !== file.name || d.size !== file.size)
		) { // if the file hasn't already been uploaded in this session
			const sendFile = (f: File) => {
				this.backendService.caricaDocumento(doc.codiceTipoDocumento, f)
					.subscribe(result => {
						if (!this.loadedFiles[doc.codiceTipoDocumento]) {
							this.loadedFiles[doc.codiceTipoDocumento] = [];
						}
						this.loadedFiles[doc.codiceTipoDocumento].push({ name: file.name, size: file.size, numeroPagina: result.numeroPagina });
						this.popupService.show('CONFIRM', 'DOC_LOADED');
						this.docs.documentiRichiesti.find(x => x.codiceTipoDocumento === doc.codiceTipoDocumento).nDocumentiCaricati++;

						this.docs.documentiCaricati.push({
							codiceTipoDocumento: doc.codiceTipoDocumento,
							numeroPagina: result.numeroPagina,
							flagInviatoCnt: false,
							flagConfermato: false,
							descrizioneTipoDocumento: `${this.capitalizeFirst.transform(this.translate.instant('PAGE'))} ${result.numeroPagina}`
						});
					},
						error => {
							console.error(error);
							let errString = 'ERR_GEN';
							if (error.status === 500) {
								switch (error.error.codiceErrore) {

									case 'INVALID_DOC_TYPE':
										errString = 'INVALID_DOC_TYPE';
										break;
									case 'CORRUPTED_PWD_PROTECTED':
										errString = 'CORRUPTED_PWD_PROTECTED';
									/*	break;
									default:
									case 'GENERIC_ERROR':
										errString = 'ERR_GEN';*/
								}
							}
							this.popupService.show('WARNING', errString);
						},
						() => {
							this.resetInput(event.target);
						}
					);
			};
			// 5 MB: since we don't know whether the limit is 5 MB or 5 MiB, in a cautious approach we limit it to 5MB frontend side */
			let consoleMessage = `File name ${file.name}`;
			if (this.fileService.validFileType(file)) { // valid type
				consoleMessage += `, file size ${this.fileService.returnFileSize(file.size, 1)}`;
				if (file.size > this.maxSize) { // Too big
					consoleMessage += 'exceeds the maximum size';
					if (file.type === 'application/pdf') { // PDFs can't be shrinked
						console.warn(`${consoleMessage} and cannot be uploaded`);
						this.popupService.show('WARNING', 'ERR_TOO_BIG', false,
							{
								filename: file.name,
								size: this.fileService.returnFileSize(this.maxSize)
							});
					} else { // Too big: to be skrinked
						console.warn(`${consoleMessage}: shrinking it.`);
						// this.popupService.show('WARNING', 'ERR_FILE_SIZE', false, { filename: file.name });
						this.fileService.getSmallerImage(this.maxSize, file)
							.subscribe(f => {
								sendFile(f);
							},
								error => {
									console.error(error);
								}
							);
					}
				} else { // OK
					console.log(`${consoleMessage}.`);
					sendFile(file);
				}
			} else { // not valid type
				console.warn(`${consoleMessage}: Not a valid file type. Update your selection.`);
				this.popupService.show('WARNING', 'ERR_FILE_TYPE', false, { filename: file.name });
			}
		}
		else {
			console.warn(`File ${file.name} already loaded`);
			this.popupService.show('WARNING', 'ERR_FILE_LOADED', false, { filename: file.name });
			this.resetInput(event.target);
		}
	}
	private readonly resetInput = (input: HTMLInputElement) => input.value = '';  // In order to allow change event to trigger also when selecting the same file twice

	onZoom(codiceTipoDocumento: string) {
		this.popupService.show(
			'DOCS_LOADED', null, false, null, null,
			this.docs.documentiCaricati.filter(x => x.flagConfermato === false),
			codiceTipoDocumento
		);
	}

	confirm() {
		this.backendService.confermaDocumenti()
			.subscribe(response => {
				location.href = (response.codiceEsito === 'OK') ? response.callbackOk : response.callbackKo;
			},
				error => {
					console.error(error);
					if (error.status === 500 && error.error.codiceErrore === 'MISSING_DOCUMENTS') {
						this.popupService.show('WARNING', 'MISSING_DOCUMENTS');
					} else {
						// if codiceErrore === 'GENERIC_ERROR'
						this.popupService.show('WARNING', 'ERR_GEN');
					}

				}
			);
	}

	/**
	 * returns true when at least a document of this.docs.documentiCaricati is confirmed
	 */
	isAnyConfirmedDoc = () => this.docs.documentiCaricati.some(x => x.flagConfermato);

	/**
	 * returns true when at least a document of this.docs.documentiCaricati is not confirmed
	 */
	isAnyNotConfirmedDoc = () => this.docs.documentiCaricati.some(x => !x.flagConfermato);

	/**
	 * the condition returns true when for any document of documentiRichiesti
	 there is at least a document of this.docs.documentiCaricati (confirmed or not) whose type corresponds
	 */
	/*areAllDocsLoaded = () =>
		this.docs.documentiRichiesti.every(
			ricDoc => this.docs.documentiCaricati.some(
				carDoc => carDoc.codiceTipoDocumento === ricDoc.codiceTipoDocumento
			)
		);*/

	getConfirmedDocs = () =>
		this.docs.documentiCaricati.filter(x => x.flagConfermato)
			.sort((a, b) => a.descrizioneTipoDocumento.localeCompare(b.descrizioneTipoDocumento))
			.reduce((acc, x, i, dc) => {
				if (i === 0 || x.codiceTipoDocumento !== dc[i - 1].codiceTipoDocumento) {
					acc.push([x]);
				} else {
					acc[acc.length - 1].push(x);
				}
				return acc;
			},
				[])
			.map(arr => arr.sort((a, b) => a.numeroPagina - b.numeroPagina))
	/**
	* says whether the limit of uploadable documents has not still reached
	*/
	moreDocsOfTypeAllowed =
		(codiceTipoDocumento: string) => this.docs.documentiCaricati.filter(x => x.codiceTipoDocumento === codiceTipoDocumento).length < this.maxFiles
}
